import { Link } from 'react-router-dom';
import { categories } from '@/mocks/doujin';

export default function Categories() {
  return (
    <section id="categories" className="bg-secondary-50/70 px-4 md:px-6 py-14 md:py-20">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <p className="flex items-center justify-center gap-2 text-secondary-700 text-sm font-medium">
            <i className="ri-grid-line"></i> CATEGORIES
          </p>
          <h2 className="mt-2 font-heading text-2xl md:text-4xl font-bold text-foreground-950">按主题找到你的同人作品</h2>
          <p className="mt-3 text-foreground-500 text-sm md:text-base max-w-2xl mx-auto">
            从治愈日常到奇幻冒险，从古风志怪到科幻悬疑，六大主题分类持续更新，总有一类适合当下的你。
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {categories.map((c) => (
            <Link
              key={c.slug}
              to={`/category/${c.slug}`}
              className="group bg-background-50 border border-background-200 rounded-lg p-6 hover:border-secondary-300 transition-colors flex items-start gap-4"
            >
              <span className="w-12 h-12 flex items-center justify-center rounded-lg bg-secondary-100 text-secondary-700 text-xl group-hover:bg-secondary-500 group-hover:text-background-50 transition-colors shrink-0">
                <i className={c.icon}></i>
              </span>
              <div className="flex-1 min-w-0">
                <div className="flex items-center justify-between">
                  <h3 className="font-heading text-lg font-semibold text-foreground-950">{c.name}</h3>
                  <span className="text-xs text-foreground-400 whitespace-nowrap">{c.count} 部</span>
                </div>
                <p className="mt-1.5 text-sm text-foreground-500 leading-relaxed">{c.description}</p>
                <span className="inline-flex items-center gap-1 mt-3 text-secondary-700 text-sm font-medium">
                  进入分类 <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform"></i>
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}